<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CUCJtZ/tc-custom/9780547538518.jpg?1728259572331" alt="This image is the cover for the book Cyberiad"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cyberiad
      </h1>
      <p class="bookDescription body article font2">
        <b>“Lem has an almost Dickensian genius for vividly realizing the tragedy and comedy of future machines.” —<i>The New York Times Book Review</i></b><br/><br/> These are the stories of Trurl and Klapaucius, master inventors and engineers known as “constructors,” who have created marvels for kingdoms. Friends and rivals, they are constantly outdoing and challenging each other to reveal the next great evolution in cybernetics, and the exploits of these brilliant men are nothing short of incredible.<br/>  <br/> From tales of love, in which a robotic prince must woo a robotic princess enchanted by pleasures of true flesh, to epics of battle, in which the heroic constructors must use their considerable wit to outsmart a monarch obsessed with hunting, to examinations of humanity, wherein Trurl and Klapaucius must confront the limits of their skills and the meaning of true perfection, these stories are rich with profound questions, unimaginable marvels, and remarkable feats.<br/>  <br/> Hailed as “the most completely successful of [Lem’s] books,” <i>The Cyberiad </i>is an outrageously funny and incomparably wise collection of short stories, taking an insightful look at mechanics, technology, invention, and human ambition (<i>The Boston Globe</i>).
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stanislaw Lem
      </h2>
      
      <p class="authorDescription body article">Stanislaw Lem is the most widely translated and best-known science fiction author outside of the English language. Winner of the Kafka Prize, he is a contributor to many magazines, including the <I>New Yorker</I>, and the author of numerous books, including <I>Solaris</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (hmhbooks.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5678f932